import { faHome } from '@fortawesome/pro-solid-svg-icons';
import { lazyComponent } from '@sokigo-sbwebb/react';
import { permissions } from '../permissions/permissions';

export default {
  name: 'sokigo-sbwebb-reflex-reflexapp',
  title: 'Reflex',
  navbar: { title: 'Hem' },
  route: '/reflex',
  icon: faHome,
  permissions,
  view: lazyComponent(() => import('../App'))
};
